export const GOOGLE = "google";
export const CUSTOM = "custom";
export const TYPEKIT = "typekit";

export default {
  CUSTOM,
  GOOGLE,
  TYPEKIT,
};
